import { defineRouting } from 'next-intl/routing';

import { supportedLocales } from '@/types/language.type';

export const routing = defineRouting({
  locales: supportedLocales,
  defaultLocale: 'en',
  localePrefix: 'as-needed',
  alternateLinks: false,
  pathnames: {
    '/': '/',
    '/services': {
      hr: '/usluge',
    },
    '/services/discovery': {
      hr: '/usluge/istrazivanje',
    },
    '/services/design': {
      hr: '/usluge/dizajn',
    },
    '/services/development': {
      hr: '/usluge/razvoj',
    },
    '/services/delivery': {
      hr: '/usluge/isporuka',
    },
    '/services/ai-strategy-discovery': {
      hr: '/usluge/ai-strategija-i-istrazivanje',
    },
    '/services/ai-search-knowledge': {
      hr: '/usluge/ai-pretraga-i-znanje',
    },
    '/services/ai-product-development': {
      hr: '/usluge/ai-razvoj-proizvoda',
    },
    '/services/ai-powered-automation': {
      hr: '/usluge/ai-automatizacija-procesa',
    },
    '/work': {
      hr: '/projekti',
    },
    '/work/[slug]': {
      hr: '/projekti/[slug]',
    },
    '/work/boat4you': {
      hr: '/projekti/boat4you',
    },
    '/work/serwizz-cmms': {
      hr: '/projekti/serwizz-cmms',
    },
    '/work/capax-service-report-app': {
      hr: '/projekti/capax-service-report-app',
    },
    '/work/des-time-tracking': {
      hr: '/projekti/des-time-tracking',
    },
    '/work/sailweek': {
      hr: '/projekti/sailweek',
    },
    '/work/cata-sailing': {
      hr: '/projekti/cata-sailing',
    },
    '/work/fgroup': {
      hr: '/projekti/fgroup',
    },
    '/work/hyperlight-optics': {
      hr: '/projekti/hyperlight-optics',
    },
    '/work/vita-benedicta': {
      hr: '/projekti/vita-benedicta',
    },
    '/work/europe-yachts': {
      hr: '/projekti/europe-yachts',
    },
    '/about': {
      hr: '/o-nama',
    },
    '/contact': {
      hr: '/kontakt',
    },
    '/blog': {
      hr: '/blog',
    },
    '/blog/[slug]': {
      hr: '/blog/[slug]',
    },
    '/blog/axios-complete-guide': {
      hr: '/blog/axios-kompletni-vodic',
    },
    '/blog/react-hook-form-complete-guide': {
      hr: '/blog/react-hook-form-kompletni-vodic',
    },
    '/blog/how-to-add-material-ui-to-your-projects': {
      hr: '/blog/kako-dodati-material-ui-u-projekt',
    },
    '/blog/how-to-add-translations-to-next-projects': {
      hr: '/blog/kako-dodati-prijevode-u-nextjs-projekt',
    },
    '/blog/how-to-add-translations-to-react-projects': {
      hr: '/blog/kako-dodati-prijevode-u-react-projekt',
    },
    '/blog/how-to-set-up-eslint-and-prettier-in-react-and-nextjs-projects': {
      hr: '/blog/kako-postaviti-eslint-i-prettier-u-react-i-nextjs',
    },
    '/blog/how-to-use-markdown-to-make-static-pages-and-blog-posts': {
      hr: '/blog/kako-koristiti-markdown-za-staticke-stranice-i-blogove',
    },
    '/blog/simplifying-state-management-in-react-with-valtio': {
      hr: '/blog/upravljanje-stanjem-u-reactu-s-valtiom',
    },
    '/blog/when-to-use-type-and-when-to-use-interface': {
      hr: '/blog/kada-koristiti-type-a-kada-interface',
    },
    '/blog/cookie-consent-data-management-and-compliance': {
      hr: '/blog/pristanak-na-kolacice-upravljanje-podacima',
    },
    '/blog/workspace-top-100-software-development-companies-techreviewer': {
      hr: '/blog/workspace-top-100-tvrtki-za-razvoj-softvera-techreviewer',
    },
    '/blog/tailwind-css-crisis-2026-what-developers-need-to-know': {
      hr: '/blog/kriza-tailwind-css-2026-sto-trebate-znati-kao-developer',
    },
    '/blog/how-to-integrate-cursor-into-your-ai-development-workflow': {
      hr: '/blog/kako-integrirati-cursor-u-vas-ai-razvojni-proces',
    },
    '/blog/our-5-favorite-figma-plugins': {
      hr: '/blog/nasih-5-najdrazih-figma-plugina',
    },
    '/blog/setting-up-gsap-in-nextjs': {
      hr: '/blog/postavljanje-gsap-a-u-nextjs-u',
    },
    '/blog/ai-driven-digital-transformation': {
      hr: '/blog/digitalna-transformacija-uz-pomoc-ai',
    },
    '/blog/ai-driven-prototyping-from-idea-to-working-product-in-days': {
      hr: '/blog/ai-driven-prototyping-od-ideje-do-proizvoda-u-nekoliko-dana',
    },
    '/blog/how-claude-skills-turn-team-expertise-into-reusable-ai-workflows': {
      hr: '/blog/kako-claude-skills-pretvaraju-timsko-znanje-u-ponovljive-ai-radne-procese',
    },
    '/blog/ai-strategy-small-business': {
      hr: '/blog/ai-strategija-za-malo-poduzetnistvo',
    },
    '/blog/ai-figma-integration-gaps': {
      hr: '/blog/ai-alati-za-dizajn-jos-nisu-na-zeljenoj-razini',
    },
    '/blog/wordpress-migration-shared-hosting-vps': {
      hr: '/blog/wordpress-migracija-shared-hosting-vps',
    },
    '/blog/how-pretext-works': {
      hr: '/blog/kako-pretext-funkcionira',
    },
    '/blog/once-again-designers-are-dead': {
      hr: '/blog/jos-jednom-dizajneri-su-mrtvi',
    },
    '/blog/whats-going-on-at-github': {
      hr: '/blog/sto-se-dogada-githubu',
    },
    '/blog/vibe-coding-prototype-to-production': {
      hr: '/blog/vibe-coding-od-prototipa-do-produkcije',
    },
    '/blog/what-a-secure-wordpress-site-looks-like': {
      hr: '/blog/kako-izgleda-sigurna-wordpress-stranica',
    },
    '/blog/ai-search-visibility': {
      hr: '/blog/zasto-vas-ai-trazilice-ne-pronalaze',
    },
    '/blog/how-to-build-a-proper-design-system': {
      hr: '/blog/kako-izgraditi-dobar-dizajn-sistem',
    },
    '/blog/npm-supply-chain-attacks-2026': {
      hr: '/blog/napadi-na-npm-pakete-2026',
    },
    '/blog/google-new-ai-powered-search': {
      hr: '/blog/google-novi-ai-agenti-za-pretragu',
    },
    '/blog/why-open-weight-models-have-openai-worried': {
      hr: '/blog/zasto-otvoreni-modeli-zabrinjavaju-openai',
    },
    '/blog/prepare-webshop-google-ai-mode-shopping': {
      hr: '/blog/kako-pripremiti-webshop-za-google-ai-mode',
    },
    '/blog/wix-collapse-2026-ai-website-builders': {
      hr: '/blog/kolaps-wixa-2026-i-ai-alati-za-izradu-web-stranica',
    },
    '/blog/eu-ai-act-transparency-obligations': {
      hr: '/blog/obveze-transparentnosti-eu-akta-o-umjetnoj-inteligenciji',
    },
    '/blog/ai-audit-for-small-business': {
      hr: '/blog/ai-pregled-za-malu-tvrtku',
    },
    '/blog/innovate-split-2026-workspace': {
      hr: '/blog/innovate-split-2026-osvrt-workspace',
    },
    '/blog/infobip-shift-2026-recap-exhibiting-in-zadar': {
      hr: '/blog/infobip-shift-2026-dojmovi-izlagaca-iz-zadra',
    },
    '/blog/llm-wiki-second-brain-ai-os': {
      hr: '/blog/llm-wiki-second-brain-ai-os-vodic-za-tvrtke',
    },
    '/blog/forward-deployed-engineer-croatia': {
      hr: '/blog/forward-deployed-engineer-hrvatska',
    },
    '/blog/from-sole-proprietorship-to-company': {
      hr: '/blog/od-obrta-do-tvrtke',
    },
    '/blog/what-is-agent-experience-ax': {
      hr: '/blog/sto-je-iskustvo-ai-agenata-ax',
    },
    '/blog/where-to-start-with-ai-in-business': {
      hr: '/blog/ai-u-poslovanju-odakle-krenuti',
    },
    '/careers': {
      hr: '/karijere',
    },
    '/office': {
      hr: '/ured',
    },
    '/expertise': {
      hr: '/specijalizacija',
    },
    '/digital-transformation': {
      hr: '/digitalna-transformacija',
    },
    '/charter-industry': {
      hr: '/charter-industrija',
    },
    '/faq': {
      hr: '/cesta-pitanja',
    },
    '/privacy-policy': {
      hr: '/pravila-privatnosti',
    },
    '/cookie-policy': {
      hr: '/pravila-kolacica',
    },
    '/legal-info': {
      hr: '/pravne-informacije',
    },
    '/ai-ethical-statement': {
      hr: '/ai-eticka-izjava',
    },
    '/llm-info': '/llm-info',
    '/reviews': {
      hr: '/recenzije',
    },
  },
});
